import React from 'react';
import {
  Box,
  HStack,
  Image,
  Modal,
  ModalCloseButton,
  ModalBody,
  ModalContent,
  ModalOverlay,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { ProductMenuModalContainer } from './ProductMenuModal_Styles';

export type ProductMenuItem = {
  key: string;
  title: string;
  img?: string;
  onClick?: () => void;
  disabled?: boolean;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  items: ProductMenuItem[];
};

const ProductMenuModal: React.FC<Props> = ({ isOpen, onClose, items }) => (
  <ProductMenuModalContainer>
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent className="modal">
        <ModalCloseButton />
        <ModalBody className="body">
          <Text className="title">
            Seletor de <b>Produtos</b>
          </Text>

          <SimpleGrid columns={3} spacing={0} className="grid">
            {items.map((item) => {
              const isDisabled = !!item.disabled;

              return (
                <Box
                  key={item.key}
                  className={`card ${isDisabled ? 'card--disabled' : ''}`}
                  onClick={() => {
                    if (isDisabled) return;
                    item.onClick?.();
                    onClose();
                  }}
                  role="button"
                >
                  {/* <Text className="cardTitle">{item.title}</Text> */}

                  <HStack justify="center" className="imgWrap">
                    {item.img ? (
                      <Image src={item.img} alt={item.title} className="img" />
                    ) : (
                      <Box className="imgFallback" />
                    )}
                  </HStack>
                </Box>
              );
            })}
          </SimpleGrid>
        </ModalBody>
      </ModalContent>
    </Modal>
  </ProductMenuModalContainer>
);

export default ProductMenuModal;
